import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import {Translation} from "@/models/Localization/Translation";
import {MethodResult} from "@/utils/API/ResultTypes/MethodResult";
import {AxiosResponse} from "axios";
import Language from "@/models/Language";


const resource = '/general';

export default {
  listCountries() {
    return Repository.post(`${resource}/ListCountries`, new ListRequest({page: 1, pageSize: 9999}), {withCredentials: true});
  },
  listIndustries() {
    return Repository.post(`${resource}/ListIndustries`, new ListRequest({page: 1, pageSize: 9999}), {withCredentials: true});
  },
  listLanguages(): Promise<AxiosResponse<MethodResult<Language[]>>> {
    return Repository.get<MethodResult<Language[]>>(`${resource}/ListLanguages`, {withCredentials: true});
  },
};
